// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_00305d', '__Inter_Fallback_00305d'","fontStyle":"normal"},"className":"__className_00305d"};